import { StyledAutocompleteLoader } from './AutocompleteLoader.styles';

export const AutocompleteLoader = () => {
  return <StyledAutocompleteLoader.Skeleton>Loading...</StyledAutocompleteLoader.Skeleton>;
};
